<template>
    <div class="tab-projects" v-loading="projectLoading">
        <div>
            <Folder
                v-if="showProjectsFolder"
                :isFoldedDefault="hasActiveProjects()"
                actions
                class="project-folder"
                title="Проекты"
                @active="tabIndex = 0"
                @finished="tabIndex = 1"
            >
                <InvolvedProjectsSPK2
                    :loading="projectsFromSPK2 === null || getInvolvedProjects === null"
                    :tabIndex="tabIndex"
                    :itemsSPK2="projectsFromSPK2 || []"
                    :itemsProjects="getInvolvedProjects || []"
                    :empty-text="'Вы еще не зарегистрированы ни на один конкурс'"
                />
            </Folder>
            <EmptyTabsCard
                v-else
                :emptyImgLink="emptyImgLink"
                cardTitle="Проекты"
                toFullRouter="/competitions"
                emptyText="Еще нет проектов"
            />
        </div>
    </div>
</template>

<script>
import Folder from '../../UI/Folder';
import declinationOfNumber from '../../../tools/declinationOfNumber';
import EmptyTabsCard from '../../UI/EmptyTabsCard';
import InvolvedProjectsSPK2 from './InvolvedProjectsSPK2';
import { formatInTimeZone } from 'date-fns-tz';

import { mapGetters, mapActions } from 'vuex';

const getters = ['getInvolvedProjects', 'getInvolvedProjectsSPK2', 'recommendedProjects', 'getRecomendedProjCount'];

const actions = ['loadInvolvedProjects', 'loadRecommendedProjects', 'loadInvolvedProjectsSPK2'];

export default {
    name: 'TabProjects',
    data: () => ({
        folders: [{ type: 'contests' }, { type: 'events' }, { type: 'internship' }],
        tabIndex: 0,
        recomendeCardsLength: 3,
        leftTabsLength: 0,
        moreBtnTxt: '',
        projectLoading: true,
        recomendationLoading: true,
    }),
    computed: {
        ...mapGetters('competitions', getters),
        recomendedSlicedItems() {
            return this.recommendedProjects.slice(0, this.recomendeCardsLength);
        },
        emptyImgLink() {
            return require(`../../../assets/images/oops-rhino.svg`);
        },
        projectsFromSPK2() {
            let projectsSPK2 = [];

            if (this.getInvolvedProjectsSPK2.data) {
                projectsSPK2 = this.getInvolvedProjectsSPK2.data.map((item) => ({
                    project_site_link: item.website,
                    status: Date.parse(new Date().toISOString()) < Date.parse(item.dateEnd) ? 'active' : 'finished',
                    description: item.greeting,
                    date_start: item.dateStart,
                    date_end: item.dateEnd,
                    project_id: item.id,
                    season_id: item.id,
                    image_link: item.logo,
                    nominations: item.nominations,
                    name: item.name,
                    alias: item.alias,
                    // userStatusId: item.participantStatusId, // оставил, ждем доработки бэка
                }));
            }

            return projectsSPK2;
        },
        showProjectsFolder() {
            return (
                (this.getInvolvedProjects && this.getInvolvedProjects.length) ||
                (this.projectsFromSPK2 && this.projectsFromSPK2.length)
            );
        },
    },
    methods: {
        ...mapActions('competitions', actions),
        hasActiveProjects() {
            let involved = this.getInvolvedProjects;
            let involvedFromSPK2 = this.projectsFromSPK2;
            let activeProjects = involved ? involved.filter((project) => project.status === 'active') : false;
            let activeProjectsSPK2 = involvedFromSPK2
                ? involvedFromSPK2.filter((project) => project.status === 'active')
                : false;
            return !!!activeProjects.length && !!!activeProjectsSPK2.length;
        },
        loadMoreCards() {
            this.recomendeCardsLength += 3;
            this.currentTabsLength();
        },
        toProjectList() {
            window.location = '/competitions';
        },
        currentTabsLength() {
            this.leftTabsLength = this.leftTabsLength ? this.leftTabsLength - 3 : this.getRecomendedProjCount - 3;
            let decTxt = declinationOfNumber(this.leftTabsLength, 'проект', 'проекта', 'проектов');
            this.moreBtnTxt = `Еще ${this.leftTabsLength} ${decTxt}`;
        },
    },
    async mounted() {
        await Promise.all([
            this.loadInvolvedProjects(),
            this.loadInvolvedProjectsSPK2(),
            this.loadRecommendedProjects(999),
            this.currentTabsLength(),
        ]);
        this.projectLoading = false;
        this.recomendationLoading = false;
    },
    components: {
        Folder,
        EmptyTabsCard,
        InvolvedProjectsSPK2,
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/rem';
@import '../../../styles/mrem';
@import '../../../styles/variables';

.project-folder {
    border-radius: rem(10);
    margin-bottom: rem(24);
    @media (max-width: $vm) {
        margin-bottom: mrem(24);
    }
}

.tab-projects {
    &__empty-projects {
        font-family: 'Circe Rounded';
        cursor: pointer;
        height: mrem(184);
        background: #ffffff;
        padding: mrem(20);
        box-shadow: mrem(0) mrem(6) mrem(10) rgba(131, 134, 163, 0.12);
        border-radius: mrem(10);

        @include on-desktop {
            height: rem(168);
            padding: rem(30);
            box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.12);
            border-radius: rem(10);
        }

        &-title {
            margin: mrem(0) mrem(0) mrem(20) mrem(0);
            font-style: normal;
            font-size: mrem(24);
            line-height: mrem(32);
            font-weight: 700;
            color: #2a2626;

            @include on-desktop {
                margin: rem(0) rem(0) rem(20) rem(0);
                font-size: rem(24);
                line-height: rem(32);
            }
        }

        &-description {
            font-style: normal;
            font-weight: 350;
            color: #2a2626;
            font-size: mrem(16);
            line-height: mrem(20);
            margin-bottom: mrem(16);

            @include on-desktop {
                font-size: rem(16);
                line-height: rem(20);
                margin-bottom: rem(16);
            }
        }

        &-more {
            cursor: pointer;
            // text-decoration: underline;
            font-style: normal;
            font-weight: 400;
            color: #4663ab;
            font-size: mrem(16);
            line-height: mrem(20);
            margin-bottom: mrem(6);
            width: mrem(272);
            border-bottom: mrem(1) solid #4663ab;

            @include on-desktop {
                font-size: rem(16);
                line-height: rem(20);
                margin-bottom: rem(0);
                width: rem(272);
                border-bottom: rem(1) solid #4663ab;
            }
        }
    }
}
</style>
